<div class="timesheet-grid" [ngStyle]="{ 'height.px': height }">
  <div class="timesheet__actions flex items-center gap-xs">
    @if (!dayIsClosed) {
      <a
        sb-icon-button
        *permission="['Create timesheets', 'Create own timesheet']; user: employeeId; department: 'any'"
        [color]="'transparent'"
        [routerLink]="['', { outlets: { modal: ['timesheet', { schedule: schedule.occurrence_id }] } }]"
        [attr.aria-label]="'Add' | translate"
      >
        <sb-icon name="add-regular" />
      </a>
    }
  </div>
</div>
